class ProductIngredients extends HTMLElement {
  constructor() {
    super();

    /* this.ingredientListHeights = [...this.nextElementSibling?.querySelectorAll('accordion-component')].map((list) => list.scrollHeight);
    this.tallestHeight = Math.max(...this.ingredientListHeights);

    if (this.tallestHeight !== -Infinity && this.tallestHeight !== NaN) {
      this.nextElementSibling.setAttribute('style', `min-height: ${this.tallestHeight}px`);
    } */

    this.addEventListener('click', this.handleClick.bind(this));

  }

  handleClick({ target }) {
    if (target.closest('h1[data-bundle-product]')) {
      const activeTrigger = this.querySelector('h1.active[data-bundle-product]');
      const activeList = this.nextElementSibling.querySelector('accordion-component.active');
      const trigger = target.closest('h1[data-bundle-product]');
      const bundleProductHandle = trigger.dataset.bundleProduct;


      if (trigger == activeTrigger) return;

      scrollTo({ top: this.parentElement.offsetTop, left: 0, behavior: 'auto'})

      activeTrigger?.classList.remove('active');
      trigger.classList.add('active');

      activeList?.classList.remove('active');
      this.nextElementSibling.querySelector(`accordion-component.${bundleProductHandle}`)?.classList.add('active');

      // this.scrollIntoView({ behavior: 'smooth' });

    }
  }
}

customElements.define('product-ingredients', ProductIngredients);
